// extracted by mini-css-extract-plugin
export default {"content":"AuthScreen_content__iafao","authContainer":"AuthScreen_authContainer__fJrrx","logoContainer":"AuthScreen_logoContainer__JzZyp","googleSSO":"AuthScreen_googleSSO__9eYwK"};